module.exports = __webpack_public_path__ + "media/product/cat-01-2fe79e5d.png";